export const HorizontalRuler = () => <hr className="my-5 border-light" />
